import React from 'react';
import classNames from 'classnames';
import { Link } from 'gatsby';
import { useDialog } from '../../contexts/DialogContext';
import FleetPortableText from './PortableText';
import HubspotForm from '../HubspotForm';

import './Button.scss';

const Button = ({ value }) => {
  const { openDialog } = useDialog();

  const {
    label = '',
    url = '#',
    theme = 'White',
    openHubspotForm,
    hubspotFormIntro,
    hubspotFormID,
  } = value;

  return (
    <>
      {openHubspotForm ? (
        <button
          className={classNames('FleetButton', `FleetButtonTheme${theme}`)}
          onClick={() =>
            openDialog(
              <>
                {hubspotFormIntro?.portableText && (
                  <FleetPortableText blocks={hubspotFormIntro.portableText} />
                )}
                {hubspotFormID && <HubspotForm formId={hubspotFormID} />}
              </>
            )
          }
        >
          <span>{label}</span>
          {theme === 'White' && (
            <span className="FleetButtonIcon">
              <ArrowIcon />
            </span>
          )}
        </button>
      ) : (
        <Link
          href={url}
          className={classNames('FleetButton', `FleetButtonTheme${theme}`)}
        >
          <span>{label}</span>
          {theme === 'White' && (
            <span className="FleetButtonIcon">
              <ArrowIcon />
            </span>
          )}
        </Link>
      )}
    </>
  );
};

const ArrowIcon = () => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6963 0.696294C11.9892 0.403401 12.4649 0.403401 12.7578 0.696295L17.5303 5.46973C17.8232 5.76263 17.8232 6.23739 17.5303 6.53028L12.7578 11.3037C12.4649 11.5966 11.9892 11.5966 11.6963 11.3037C11.4034 11.0108 11.4034 10.5351 11.6963 10.2422L15.1895 6.75001L-5.48436e-07 6.75L-4.17302e-07 5.25L15.1895 5.25001L11.6963 1.75782C11.4034 1.46492 11.4034 0.989188 11.6963 0.696294Z"
      fill="white"
    />
  </svg>
);

export default Button;
